import { HttpErrorResponse } from '@angular/common/http';

/** SUP-01: a problem report may carry the last client errors, when the reporter agrees. */
const MAX_ERRORS = 20;
const MAX_LENGTH = 500;

const errors: string[] = [];

/** Remembers an uncaught browser error (message and page) for a problem report. Failed HTTP calls are the API's to log. */
export function recordClientError(error: unknown, page: string = typeof location === 'undefined' ? '' : location.pathname): void {
  const wrapped = error as { rejection?: unknown } | null | undefined;
  const original = wrapped?.rejection ?? error;
  if (original instanceof HttpErrorResponse) return;
  const message = String((original as { message?: unknown } | null | undefined)?.message ?? original ?? '').trim();
  if (!message) return;
  errors.push(`${new Date().toISOString()} ${page} ${message}`.slice(0, MAX_LENGTH));
  if (errors.length > MAX_ERRORS) errors.splice(0, errors.length - MAX_ERRORS);
}

/** The last client errors, oldest first. */
export function recentClientErrors(): string[] {
  return [...errors];
}

/** For specs. */
export function clearClientErrors(): void {
  errors.length = 0;
}
